export const FETCH_DOCUMENTS = "/member-documents/list/";
export const DELETE_DOCUMENT_FILE = "/member-documents/:memberId/delete_document/:key/";
export const DOWNLOAD_DOCUMENT = "/member-documents/:memberId/fetch_document/:key/";
export const FETCH_DOCUMENT_FOLDER_DETAILS = "/member-documents/list/:memberId/:folderKey/";
export const EDIT_DOCUMENT = "/member-documents/:memberId/update_category/";
